import React, {useEffect, useState} from 'react';
import SponsorshipInfoComponent from '../../../Components/UserComponents/SponsorshipInfo';

const SponsorshipInfoContainer = () => {
  return <SponsorshipInfoComponent />;
};

export default SponsorshipInfoContainer;
